export interface InstallPromptEvent extends Event {
  prompt(): Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

type Listener = (available: boolean) => void

export class AppInstaller {
  private promptEvent: InstallPromptEvent | undefined
  private readonly listeners = new Set<Listener>()

  constructor() {
    addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault()
      this.promptEvent = event as InstallPromptEvent
      this.emit()
    })
    addEventListener('appinstalled', () => { this.promptEvent = undefined; this.emit() })
  }

  available(): boolean { return this.promptEvent !== undefined }
  appleManualInstallAvailable(): boolean {
    const appleMobile = /iPad|iPhone|iPod/i.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    const standalone = 'standalone' in navigator && Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
    return appleMobile && !standalone
  }
  subscribe(listener: Listener): () => void { this.listeners.add(listener); return () => this.listeners.delete(listener) }
  async install(): Promise<'accepted' | 'dismissed' | 'unavailable'> {
    const event = this.promptEvent
    if (!event) return 'unavailable'
    await event.prompt()
    const choice = await event.userChoice
    if (choice.outcome === 'accepted') this.promptEvent = undefined
    this.emit()
    return choice.outcome
  }
  private emit(): void { for (const listener of this.listeners) listener(this.available()) }
}

export const appInstaller = new AppInstaller()
